module.exports = __webpack_public_path__ + "static/media/burqa.5fc1224a.png";